import { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="#" className="text-2xl font-bold text-emerald-600 cursor-pointer" style={{ fontFamily: '"Pacifico", serif' }}>
              CMAP運動健康品格寒假營隊
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <a href="#home" className="text-gray-900 hover:text-emerald-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer">
                首頁
              </a>
              <a href="#about" className="text-gray-700 hover:text-emerald-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer">
                關於我們
              </a>
              <a href="#programs" className="text-gray-700 hover:text-emerald-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer">
                營隊活動
              </a>
              <a href="#gallery" className="text-gray-700 hover:text-emerald-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer">
                活動花絮
              </a>
              <a href="#contact" className="text-gray-700 hover:text-emerald-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer">
                聯絡我們
              </a>
              <a href="#register" className="bg-emerald-600 text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap">
                立即報名
              </a>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="text-gray-700 hover:text-emerald-600 focus:outline-none focus:text-emerald-600 cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
              </div>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
              <a href="#home" className="text-gray-900 hover:text-emerald-600 block px-3 py-2 text-base font-medium cursor-pointer">
                首頁
              </a>
              <a href="#about" className="text-gray-700 hover:text-emerald-600 block px-3 py-2 text-base font-medium cursor-pointer">
                關於我們
              </a>
              <a href="#programs" className="text-gray-700 hover:text-emerald-600 block px-3 py-2 text-base font-medium cursor-pointer">
                營隊活動
              </a>
              <a href="#gallery" className="text-gray-700 hover:text-emerald-600 block px-3 py-2 text-base font-medium cursor-pointer">
                活動花絮
              </a>
              <a href="#contact" className="text-gray-700 hover:text-emerald-600 block px-3 py-2 text-base font-medium cursor-pointer">
                聯絡我們
              </a>
              <a href="#register" className="bg-emerald-600 text-white block px-3 py-2 rounded-lg text-base font-medium hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap">
                立即報名
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
